<template>
  <!-- <CooperatedBrand style="height: 100%"></CooperatedBrand> -->
  <router-view />
  <!-- 固定在右边的模块 -->
  <FixedRightSideModule> </FixedRightSideModule>
</template>

<script>
// import CooperatedBrand from "@/views/home/components/cooperatedBrand/cooperatedBrand.vue";
import { isMobile } from "@/utils/other.js";
import { provide, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import FixedRightSideModule from "@/components/fixedRightSideModule/fixedRightSideModule.vue";
 
export default {
  components: {
    // CooperatedBrand,
    FixedRightSideModule,
  },
  setup() {
    const store = useStore();
    store.dispatch("global/getSetAllAdv");

    const isMobileDevice = ref(isMobile());

    window.onresize = function () {
      isMobileDevice.value = isMobile();
    };



    provide("isMobile", isMobileDevice);
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
